import React from "react";
// Components
import { TableBody, TableHead } from "./components";
// Hooks
import useActions from "hooks/useActions";
// Store Utils
import { useDispatch } from "react-redux";
// Utils
import exportDataToCsv from "utils/exportDataToCsv";
import getAllRowsData from "utils/getAllRowsData";
// Exteranl Tools
import { snakeCase } from "change-case";
// types
import { TableProps } from "./types";
import { pollsAndSurveysSortingAction } from "store/filters/reducer.actions";
import { Toasts } from "view/components/Toasts";
import apiLibrary from "services/api";
import { filterKeys } from "Components/Users/Table";

export const KEYS_TO_BE_REMOVED = ["archivedBy"];

const generatingDirectoryActions = (columns: any, rowsData: any) => {
  const fileDownload = async () => {
    if (rowsData.length === 0) {
      Toasts.error("Please select at least one survey from the table");
      return;
    }
    try {
      const res = await apiLibrary.file.fileDownload(
        "survey_and_polls",
        columns,
        rowsData.map((item: any) => {
          return item.surveyName.id;
        })
      );

      // Convert the response to a Blob
      const blob = new Blob([res], { type: "application/octet-stream" });

      // Create a link element
      const link = document.createElement("a");

      // Set the href attribute to a URL created from the Blob
      link.href = window.URL.createObjectURL(blob);

      // Set the download attribute to specify the file name
      link.download = `pollsAndSurvey_${new Date().toISOString()}.csv`;

      // Append the link to the body
      document.body.appendChild(link);

      // Programmatically click the link to trigger the download
      link.click();

      // Remove the link from the DOM
      document.body.removeChild(link);

      Toasts.success("Download complete");
    } catch (error: any) {
      const errorMsg = error?.response?.data?.message ?? error?.message;
      Toasts.error(errorMsg);
    }
  };

  return [
    {
      label: "Export Details",
      onClick: () => fileDownload(),
      divider: false,
      isVisible: true,
    },
  ];
};

export const Table: React.FC<TableProps> = ({
  table,
  columnOrder,
  columns,
  columnVisibility,
  flexRender,
  setSorting,
  sorting,
}) => {
  const dispatch = useDispatch();
  const { pollsAndSurveysActions } = useActions();
  const DirectoryActions = () => {
    const filteredKeys = filterKeys(columnVisibility, columnOrder);
    return generatingDirectoryActions(
      filteredKeys,
      getAllRowsData(table, columnOrder, columnVisibility, columns)
    );
  };

  const getPollsAndSurveysActionss = (data: any) => {
    const modalData = {
      name: data?.surveyName?.name,
      pictureId: data?.surveyName?.picture?.id,
      imageUrl: "",
      id: data?.surveyName?.id,
      status: data?.status,
      description: data?.description,
      token: data?.token,
      program: data?.programName,
      surveyAndPollVersionId: data.surveyAndPollVersionId,
      path: "directory",
    };

    return pollsAndSurveysActions(modalData);
  };

  const toggleSorting = (columnId: string) => {
    setSorting((currentSorting: any) => {
      const existingSort = currentSorting.find(
        (sort: any) => sort.columnId === columnId
      );
      const columnsId = snakeCase(columnId);
      if (!existingSort) {
        dispatch(pollsAndSurveysSortingAction(columnsId, "asc"));

        return [{ columnId, type: "asc" }];
      } else if (existingSort.type === "asc") {
        dispatch(pollsAndSurveysSortingAction(columnsId, "desc"));

        return [{ columnId, type: "desc" }];
      } else {
        dispatch(pollsAndSurveysSortingAction("", ""));

        return [];
      }
    });
  };
  const handleClickOnTableColumnHeading = (header: any) =>
    header.column.getCanSort() && toggleSorting(header.column.id);
  return (
    <div className="w-full overflow-hidden overflow-x-auto max-h-[80vh] overflow-y-auto">
      <table className="">
        <TableHead
          table={table}
          sorting={sorting}
          flexRender={flexRender}
          DirectoryActions={DirectoryActions()}
          handleClickOnColumnHead={handleClickOnTableColumnHeading}
        />
        <TableBody
          flexRender={flexRender}
          table={table}
          columnVisibility={columnVisibility}
          getPollsAndSurveysActions={getPollsAndSurveysActionss}
        />
      </table>
    </div>
  );
};
